export default __webpack_public_path__ + "static/media/roadmap-q2.fbe37b84.png";